<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警诊断
        </span>

        <div class="tableWrapper">
          <downloadBtn url="extra/alarmDiagnosis/export/exportList" :params="seefrom" method="post" :needUserId="true"></downloadBtn>
          <br />
          <br />
          <span style="color: #F2F8FE"> 下载说明：</span><br/>
          <span style="color: #F2F8FE">（1）导出数据文件为Excel格式；</span><br />
          <span style="color: #F2F8FE">（2）导出数据形式为设备名称、设备编码、设备状态、设备类型、所属区域、所属部门、部门人员、告警通知方式；</span><br />
          <span style="color: #F2F8FE">（3）导出数据内容为所有已注册但未关联区域、关联区域未关联部门、关联部门未关联人员、无告警通知方式的设备信息列表；</span><br />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return {

        tabName: "jsgl",
        form_jsgl: {},
        title: "",
        other: {},
        items: [],
        seefrom: {
          systemId: "",
          deviceType: "",
          regionId: "",
          curAreaName: "",
        },
        addEquipment: {
          systemId: "",
          deviceType: "",
          pumpType: null,
        },
        //区域树是否显示
        areaTreeVisible: false,
        areaTreeMode: true,
        //选择区域树模式 查询 ？ 新增 ？
        areaMode: 1,
        seeDisplayForm: false,
        displayForm: false,
        SystemId: [],
        options: [],
        //上传文件
        addArr: [],
        tableData: [],
        //设备额外信息
        equipment: {
          protocolTypeName: "",
        },
        //设备种类（网关）
        deviceKind: "",
      };
    },
    computed: {
      self() {
        return this;
      },

      dt() {
        return dt.map(({ label }) => label);
      },
    },
    components: {
      normalNav: () => import("public/normalNav"),
      searchForm: () => import("public/searchForm"),
      easyTable: () => import("public/easyTable"),
      mountPoint: () => import("public/mountPoint"),
      downloadBtn:() => import('public/download'),
    },
    methods: {

    },
    mounted() {

    },
  };
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/alarmDiagnosis.vue